function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n\n  padding: 8px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import EditorContainer from "../../../editor";
import styled from "styled-components";
import { ChangeLogView } from "../ChangeLogView";
import { useProvidedBuilder } from "../DocumentEditorWrapper";
var DocumentEditor = function(_param) {
    var disabled = _param.disabled, _height = _param.height, height = _height === void 0 ? "600px" : _height, rest = _objectWithoutProperties(_param, [
        "disabled",
        "height"
    ]);
    var builder = useProvidedBuilder();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Tab, {
        isHidden: builder.view !== "default"
    }, /*#__PURE__*/ React.createElement(EditorContainer, _extends({
        disabled: builder.isLoading || builder.isSubmitting || disabled,
        value: builder.html,
        onChange: function(value) {
            var ref, ref1;
            var html = (value === null || value === void 0 ? void 0 : (ref = value.target) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.value) || (value === null || value === void 0 ? void 0 : value.editor) || value;
            if (typeof html !== "string") return;
            return builder.setHtml(html);
        },
        height: height
    }, rest))), builder.view === "changeLog" && /*#__PURE__*/ React.createElement(Tab, null, /*#__PURE__*/ React.createElement(ChangeLogView, {
        show: true
    })));
};
export { DocumentEditor };
var Tab = styled.div(_templateObject(), function(props) {
    return props.isHidden ? "none" : "block";
});
